<script setup lang="ts">
import {computed} from "vue";
import ChatUtils from "@/utils/common/ChatUtils.ts";
import ChatMediaMenu from "@/components/navBar/chat/ChatMediaMenu.vue";
import ChatMessageTicks from "@/components/navBar/chat/ChatMessageTicks.vue";
import {MessageMetadata} from "@/utils/presenters/interfaces.ts";

const props = defineProps<{
  message: MessageMetadata;
  sent: boolean;
  stamp: string;
  status?: string;
  darkMode: boolean;
}>();

const emit = defineEmits<{
  preview: [src: string, fileName: string];
}>();

const fileId = computed(() => props.message.attachment?.attachmentInfo?.fileId);
const fileName = computed(() => props.message.attachment?.attachmentInfo?.fileName ?? '');
const downloadUrl = computed(() => ChatUtils.getFileDownloadUrl(fileId.value));
const imageSrc = computed(() => ChatUtils.getFileDownloadUrl(fileId.value));
const caption = computed(() => props.message.messageContent?.trim() || '');

function onImageClick() {
  emit('preview', imageSrc.value, fileName.value);
}
</script>

<template>
  <div class="chat-image-bubble tw-max-w-[280px] tw-rounded-lg tw-overflow-hidden tw-cursor-pointer tw-relative tw-group"
       :class="[sent ? 'tw-self-end' : 'tw-self-start']"
       @click="onImageClick">
    <img :src="imageSrc" :alt="fileName"
         class="tw-w-full tw-max-h-[300px] tw-object-cover tw-block tw-rounded-lg"
         loading="lazy"/>
    <div class="tw-absolute tw-top-1 tw-right-1 tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity" @click.stop>
      <ChatMediaMenu :download-url="downloadUrl" btn-class="tw-bg-black/40 tw-text-white"/>
    </div>
    <div class="tw-absolute tw-bottom-1 tw-right-2 tw-bg-black/40 tw-rounded tw-px-1.5 tw-py-0.5 tw-text-[10px] tw-text-white tw-inline-flex tw-items-center tw-gap-1">
      <span v-text="stamp"/>
      <ChatMessageTicks v-if="sent" :status="status"/>
    </div>
    <div v-if="caption"
         class="tw-px-2 tw-py-1.5 tw-text-sm"
         :class="[sent ? 'tw-bg-[var(--q-primary)] tw-text-white' : (darkMode ? 'tw-bg-gray-800 tw-text-white' : 'tw-bg-gray-200 tw-text-gray-900')]"
         v-text="caption"/>
  </div>
</template>
